export default __webpack_public_path__ + "static/media/log-in-feature-small.a1ae6f00.png";